import { useState } from "react";
import { useNotification } from "@hooks/useNotifications";
import { tokenManager } from "@libs/token-manager";

const useFileDownloader = () => {
  const [isLoading, setLoading] = useState(false);
  const { showError } = useNotification();

  const downloadFile = async (url: string, fileId: string) => {
    try {
      setLoading(true);
      const token = tokenManager.getAccessToken();

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        showError(`Failed to download: ${response.statusText}`);
        return;
      }

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = fileId;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      showError(`Failed to download: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return { downloadFile, isLoading };
};

export default useFileDownloader;
